export default "__VITE_ASSET__DrOGpqPZ__"